import { customHtml } from '@yola/ws-sdk';
import constants from '../constants';
import getKeywordsList from './get-keywords-list';
import trimLocaleSuffixFromPath from './trim-locale-suffix-from-path';
import addIdsToCustomCodeSnippets from '../../common/helpers/add-ids-to-custom-code-snippets';

const { fieldNames } = constants;
const customCodeFieldNamesList = Object.values(customHtml.constants.fieldNames);

const OPTIONAL_STRING_FIELDS = [
  fieldNames.TITLE,
  fieldNames.DESCRIPTION,
  fieldNames.OG_TITLE,
  fieldNames.OG_DESCRIPTION,
  fieldNames.OG_IMAGE,
  fieldNames.CANONICAL_URL,
];

const OPTIONAL_FLAG_FIELDS = [
  fieldNames.USE_PAGE_NAME_FOR_PAGE_TITLE,
  fieldNames.PREVENT_INDEXING,
  fieldNames.USE_PAGE_TITLE_FOR_OG_TITLE,
  fieldNames.USE_PAGE_DESCRIPTION_FOR_OG_DESCRIPTION,
  fieldNames.USE_PAGE_URL_FOR_CANONICAL_URL,
];

const getFieldsWithFallback = (pageSettings, fields, fallback) =>
  Object.fromEntries(fields.map((field) => [field, pageSettings[field] ?? fallback]));

const getCustomCodeDefaults = (pageSettings) =>
  Object.fromEntries(
    customCodeFieldNamesList.map((type) => [
      type,
      addIdsToCustomCodeSnippets(pageSettings[type] || []),
    ])
  );

const getPageSettingsDefaultValues = ({
  pageSettings,
  isMultilingualSite,
  isPageInNavigation,
  isPasswordProtectedPagesFeatureFlagEnabled,
  isBusinessInfoInWebsiteSettingsFeatureFlagEnabled,
}) => ({
  [fieldNames.NAME]: pageSettings[fieldNames.NAME],
  [fieldNames.HTML_LOCALE]: pageSettings[fieldNames.HTML_LOCALE],
  [fieldNames.PATH]: isMultilingualSite
    ? trimLocaleSuffixFromPath(pageSettings[fieldNames.PATH])
    : pageSettings[fieldNames.PATH],
  [fieldNames.DISPLAY_IN_NAVIGATION]: isPageInNavigation,
  [fieldNames.KEYWORDS]: getKeywordsList(pageSettings[fieldNames.KEYWORDS]),
  ...getFieldsWithFallback(pageSettings, OPTIONAL_STRING_FIELDS, ''),
  ...getFieldsWithFallback(pageSettings, OPTIONAL_FLAG_FIELDS, false),
  ...(isPasswordProtectedPagesFeatureFlagEnabled && {
    [fieldNames.PASSWORD]: pageSettings[fieldNames.PASSWORD] ?? '',
  }),
  ...(isBusinessInfoInWebsiteSettingsFeatureFlagEnabled && {
    [fieldNames.USE_BUSINESS_NAME_IN_PAGE_TITLE]:
      pageSettings[fieldNames.USE_BUSINESS_NAME_IN_PAGE_TITLE] ?? false,
  }),
  ...getCustomCodeDefaults(pageSettings),
});

export default getPageSettingsDefaultValues;
